import styles from "modules/home/service-section.module.scss";

function ServiceSection(props: any) {
  return (
    <div className={`${styles.section} ${props.className}`}>
      {props.children}
    </div>
  );
}

export default ServiceSection;
